import React from "react";

function TransactionComplaintView(props) {
  return <div></div>;
}

export default TransactionComplaintView;
